var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtRisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#EE3B58",
    cx: 25,
    cy: 24.999,
    r: 24.211
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.207,31.086l-9.732-16.3c-0.735-1.239-2.035-1.979-3.475-1.979c-1.441,0-2.74,0.74-3.476,1.979 l-9.732,16.3c-0.751,1.266-0.765,2.785-0.038,4.063c0.729,1.279,2.041,2.043,3.514,2.043h19.464c1.473,0,2.785-0.764,3.515-2.043 C38.973,33.871,38.958,32.352,38.207,31.086z M25,17.791c0.892,0,1.616,0.724,1.616,1.617v6.467c0,0.893-0.724,1.618-1.616,1.618 c-0.893,0-1.617-0.725-1.617-1.618v-6.467l0,0C23.383,18.515,24.106,17.791,25,17.791z M25,33.959 c-1.337,0-2.425-1.088-2.425-2.426s1.088-2.426,2.425-2.426c1.336,0,2.425,1.088,2.425,2.426 C27.424,32.871,26.336,33.959,25,33.959z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtRisk);
export default __webpack_public_path__ + "static/media/AtRisk.2e8693a039531222db61b82789b79706.svg";
export { ForwardRef as ReactComponent };